import { render } from "./OrderCreate.vue?vue&type=template&id=48042330&scoped=true&ts=true"
import script from "./OrderCreate.vue?vue&type=script&lang=ts"
export * from "./OrderCreate.vue?vue&type=script&lang=ts"

import "./OrderCreate.vue?vue&type=style&index=0&id=48042330&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48042330"]])

export default __exports__